import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, makeStyles, MenuItem, Paper, Select, Theme, Typography } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps, TipoPrevidenza } from '../../types/types';
import { API_elaboraIForfetari } from '../../utils/functions';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         formControl: {
//             margin: theme.spacing(1),
//             // minWidth: 320,
//             border: '1px solid black'
//         },
//         select: {
//             width: "10rem",
//         },
//         selectLong: {
//             width: "13rem",
//         },
//         bottomControlLabel: {
//             verticalAlign: 'bottom',
//         },
//     }),
// );

export default function GestionePrevidenziale(props: DefaultInputProps) {
    //HACK vmorell 20210310 uso sempre gli stessi stili
    // const classes = useStyles();
    const gClasses = globalStyles();
    const action = "changeGestionePrevidenziale";
    const [global] = useGlobal<IGlobalState>();

    const { state } = props;

    const handleChange = (e: any) => {
        console.log(e);
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraIForfetari(props, global, name, value, action, true);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraIForfetari(props, global, name, checked, action, true);
    }

    let errorJ49 = ((state.tipologia === "IMPRESA" && (state.gestionePrevidenziale.aliquotaSep > 0 || state.gestionePrevidenziale.cassaProfessionale)) || (state.tipologia === "PROFESSIONE" && (state.gestionePrevidenziale.tipoPrevidenza.valueOf() === TipoPrevidenza.Artigianato.valueOf() || state.gestionePrevidenziale.tipoPrevidenza.valueOf() === TipoPrevidenza.Commercio.valueOf())));

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionSubTitle text="Gestione previdenziale"></SectionSubTitle>
            <Grid container>
                <Grid item md={4} xs={12}>     
                <FormControl className={gClasses.formControl} disabled={state.gestionePrevidenziale.aliquotaSep !== 0 || state.gestionePrevidenziale.cassaProfessionale}>
                    <InputLabel htmlFor="tipoPrevidenza">IVS Artigianato/Commercio</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.gestionePrevidenziale.tipoPrevidenza}
                        onChange={handleChangeSelect}
                        inputProps={{
                            name: 'tipoPrevidenza',
                            id: 'tipoPrevidenza',
                        }}
                    >
                        <MenuItem value={"NON DEFINITO"}>Non definito</MenuItem>
                        <MenuItem value={"ARTIGIANATO"}>Artigianato</MenuItem>
                        <MenuItem value={"COMMERCIO"}>Commercio</MenuItem>
                    </Select>
                </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>     
                <FormControl className={gClasses.formControl} disabled={state.gestionePrevidenziale.tipoPrevidenza !== "NON DEFINITO" || state.gestionePrevidenziale.cassaProfessionale}>
                    <InputLabel htmlFor="aliquotaSep">Aliquota gestione separata</InputLabel>
                    <Select
                        className={gClasses.select}
                        value={state.gestionePrevidenziale.aliquotaSep}
                        onChange={handleChangeSelect}
                        inputProps={{
                            name: 'aliquotaSep',
                            id: 'aliquotaSep',
                        }}
                    >
                        <MenuItem value={0}>Non definito</MenuItem>
                        <MenuItem value={24}>24</MenuItem>
                        <MenuItem value={26.23}>26.23</MenuItem>
                    </Select>
                </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>     
                <FormControlLabel
                    disabled={state.gestionePrevidenziale.aliquotaSep !== 0 || state.gestionePrevidenziale.tipoPrevidenza !== "NON DEFINITO"}
                    className={gClasses.bottomControlLabel}
                    labelPlacement="end"
                    control={
                        <Checkbox
                            checked={state.gestionePrevidenziale.cassaProfessionale}
                            onChange={handleChangeChecked}
                            name='cassaProfessionale'
                            id='cassaProfessionale'
                            inputProps={{
                                'aria-label': 'primary checkbox',
                            }
                            } />} label="Cassa professionale" />

                {errorJ49 === true ? <Typography style={{ marginTop: "8px" }} variant="body1" color="error">Non coerente con tipologia</Typography> : <p></p>}
                </Grid>
           </Grid>
        </Paper>
    );
}